interface PillToggleProps {
  options: readonly [string, string];
  value: string;
  onChange: (next: string) => void;
}

/**
 * Segmented two-option pill — visual control to swap between e.g.
 * 'Address book' and 'Manual'. Replaces a HeroUI Switch where the
 * design needs the two states to be equally weighted (no on/off
 * implication).
 */
export function PillToggle({ options, value, onChange }: PillToggleProps) {
  return (
    <div className="inline-flex p-0.5 gap-0 bg-default-100 rounded-full text-xs font-semibold">
      {options.map((opt) => {
        const active = value === opt;
        return (
          <button
            key={opt}
            type="button"
            onClick={() => onChange(opt)}
            className={`px-3 py-1.5 rounded-full transition-colors ${
              active
                ? "bg-background text-default-900 shadow-sm"
                : "bg-transparent text-default-500 hover:text-default-700"
            }`}
          >
            {opt}
          </button>
        );
      })}
    </div>
  );
}
